import axios from './axiosConfig';
import NotificationService from './NotificationService';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://api.local.dev:8080'}/api/shop`;

class CategoryService {
  static async getCategories() {
    try {
      const response = await axios.get(`${API_URL}/categories/list`);
      return response.data.data;
    } catch (error) {
      NotificationService.error('Erreur lors du chargement des catégories');
      console.error('Erreur lors de la récupération des catégories:', error);
      return [];
    }
  }
}

export default CategoryService;
